import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    annualIncomeMaxRange: '57,000 or more',
    legalAnnualTurnoverMaxRange: '100 million or more',
    legalNumberOfEmployeeMaxRange: '250 or more',
    million: 'million',
    millionPlural: 'million',
    personalAssetsMaxRange: '465,000 or more',
  },
  fr: {
    annualIncomeMaxRange: '57 000 ou plus',
    legalAnnualTurnoverMaxRange: '100 millions ou plus',
    legalNumberOfEmployeeMaxRange: '250 ou plus',
    million: 'million',
    millionPlural: 'millions',
    personalAssetsMaxRange: '465 000 ou plus',
  },
});
